import Loading from "../../General/Loading";
import { Col, Row, Card, Collapse, Container, Button } from "react-bootstrap";
import { Modal, Form, InputGroup } from "react-bootstrap";
import styles from "./PaquetedeDatos.module.css";
import { useState, useEffect } from "react";
import Slider from "react-slick";
import arrowNext from "../../assets/img/Iconos/arrowNext.png";
import arrowPrev from "../../assets/img/Iconos/arrowPrev.png";
import {
  ConsultaPaqAdicionalDatosRest_Entrada,
  builtConsultaPaqAdicionalDatosRestInput,
  ConsultaPaqAdicionalDatosRest_Parametros,
  ConsultaPaqAdicionalDatosRest_Respuesta,
  PaqueteAdicionalDato,
} from "../../Commons/Services/ConsultaPaqAdicionalDatosRest";
import { ConsultaWS } from "../../Commons/ServiciosBase";
import ConfirmMessage from "../..//General/ConfirmMessage";
import {
  GestionarSSComprarDatosRest_Parametros,
  GestionarSSComprarDatosRest_Entrada,
  builtGestionarSSComprarDatosRest_Entrada,
  GestionarSSComprarDatosRequestEBM,
  builtGestionarSSComprarDatosRequestEBM,
  Product,
  builtProduct,
  ListOfProducts,
  builtListOfProducts,
  Instance,
  builtInstance,
  ListOfInstances,
  builtListOfInstances,
  ServiceInfoRequest,
  builtServiceInfoRequest,
  GestionarSSComprarDatosRest_Respuesta,
} from "../../Commons/Services/GestionarSSComprarDatosRest";
const PaquetedeDatos = () => {
  const [status, setStatus] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, isLoading] = useState(false);
  const [showMOdalConfirmacion, setShowMOdalConfirmacion] = useState(false);
  const [nombrePaqueteSeleccionado, setnombrePaqueteSeleccionado] =
    useState("");
  const [precioPaqueteSeleccionado, setPrecioPaqueteSeleccionado] =
    useState("");
  const [paqueteAdicionalDatos, setPaqueteAdicionalDatos] = useState<
    PaqueteAdicionalDato[]
  >([]);
  const [showAlertError, setShowAlertError] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");

  function ArrowPrev2(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
        className={className}
        style={{ ...style, width: "1px", height: "auto" }}
      >
        <img src={arrowPrev} />
      </div>
    );
  }

  function ArrowNext2(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
        className={className}
        style={{ ...style, width: "1px", height: "auto" }}
      >
        <img src={arrowNext} />
      </div>
    );
  }

  const settings2 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <ArrowNext2 />,
    prevArrow: <ArrowPrev2 />,
  };

  useEffect(() => {
    isLoading(true);
    doConsultaPaqAdicionalDatosRest();
  }, []);

  const doConsultaPaqAdicionalDatosRest = async () => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultaPaqAdicionalDatosRestEntrada: ConsultaPaqAdicionalDatosRest_Entrada =
        builtConsultaPaqAdicionalDatosRestInput(
          `${sessionStorage.getItem("assetNumber")}`, //
          `${sessionStorage.getItem("cuenta")}`,
          "Sky Mexico"
        );
      let ConsultaPaqAdicionalDatosRestParametros =
        ConsultaPaqAdicionalDatosRest_Parametros(
          ConsultaPaqAdicionalDatosRestEntrada
        );
      let ConsultaPaqAdicionalDatosRestRespuesta: ConsultaPaqAdicionalDatosRest_Respuesta =
        await ConsultaWS(ConsultaPaqAdicionalDatosRestParametros);
      if (
        ConsultaPaqAdicionalDatosRestRespuesta.EBMHeaderResponse &&
        ConsultaPaqAdicionalDatosRestRespuesta.EBMHeaderResponse.ErrorNegocio
          .Estado == "ok" &&
        ConsultaPaqAdicionalDatosRestRespuesta.EBMHeaderResponse.ErrorTecnico
          .code === "ok"
      ) {
        setPaqueteAdicionalDatos(
          ConsultaPaqAdicionalDatosRestRespuesta.PaquetesAdicionalesDatos
            .PaqueteAdicionalDatos
        );
      } else {
      }

      isLoading(false);
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
  };

  const contratarPaqueteDatos = async (
    p_NombreProductoCRM: string,
    p_Costo: string
  ) => {
    setnombrePaqueteSeleccionado(p_NombreProductoCRM);
    setPrecioPaqueteSeleccionado(p_Costo);
    setShowMOdalConfirmacion(true);
  };

  const handleMOdalConfirmacion = () => {
    setnombrePaqueteSeleccionado("");
    setPrecioPaqueteSeleccionado("");
    setShowMOdalConfirmacion(false);
  };

  const doGestionarSSComprarDatosRest = async () => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------

      const product: Product = builtProduct("Add", nombrePaqueteSeleccionado);
      const listOfProducts: ListOfProducts = builtListOfProducts([product]);
      const instance: Instance = builtInstance(
        `${sessionStorage.getItem("assetNumber")}`,
        listOfProducts
      );
      const listOfInstances: ListOfInstances = builtListOfInstances([instance]);
      const serviceInfoRequest: ServiceInfoRequest = builtServiceInfoRequest(
        `${sessionStorage.getItem("cuenta")}`,
        listOfInstances,
        "Web"
      );
      const gestionarSSComprarDatosRequestEBM: GestionarSSComprarDatosRequestEBM =
        builtGestionarSSComprarDatosRequestEBM(serviceInfoRequest);
      const GestionarSSComprarDatosRestEntrada: GestionarSSComprarDatosRest_Entrada =
        builtGestionarSSComprarDatosRest_Entrada(
          gestionarSSComprarDatosRequestEBM
        );

      let GestionarSSComprarDatosRestParametros =
        GestionarSSComprarDatosRest_Parametros(
          GestionarSSComprarDatosRestEntrada
        );
      let GestionarSSComprarDatosRestRespuesta: GestionarSSComprarDatosRest_Respuesta =
        await ConsultaWS(GestionarSSComprarDatosRestParametros);
      isLoading(false);
      if (
        GestionarSSComprarDatosRestRespuesta.EBMHeaderResponse &&
        GestionarSSComprarDatosRestRespuesta.EBMHeaderResponse.ErrorNegocio
          .Estado == "ok" &&
        GestionarSSComprarDatosRestRespuesta.EBMHeaderResponse.ErrorTecnico
          .code === "ok"
      ) {
        //
        showAlertocal(
          "OK",
          "Notificación de crecimiento No. SS: " +
            GestionarSSComprarDatosRestRespuesta
              .GestionarSSComprarDatosResponseEBM.ServiceInfoResponse.NumeroSS +
            ", Necesaria para seguimiento"
        );
      } else {
        showAlertocal("OK", "error al obtener datos del servicio");
        console.error(GestionarSSComprarDatosRestRespuesta);
      }

      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      showAlertocal("OK", "error al ejecutar el servicio");
      console.error(error);
    }
  };

  const showAlertocal = (p_estado: string, p_mensaje: string) => {
    setStatus(p_estado);
    setMessage(p_mensaje);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
      handleMOdalConfirmacion();
    }, 3000);
  };

  return (
    <>
      <Loading isLoading={loading} />

      <Container fluid>
        <Row className={styles["headerRow"]}>
          <Col>
            <span className={styles["spectrum"]}>Adicionales</span>

            <p className={styles["title"]}>
              Contrata paquetes de datos adicionales a tu plan para que no te
              quedes sin conexión
            </p>
          </Col>
        </Row>
        <Row className={styles["headerRow"]}>
          <Col>
            <span className={styles["subtitle"]}>Paquetes de datos</span>
            <p className={styles["title"]}>
              Estos son los paquetes de datos que puedes agregar a tu plan.
            </p>
          </Col>
        </Row>

        <Row className={styles["rowCards"]}>
          <Slider {...settings2}>
            {paqueteAdicionalDatos.map(
              (paqueteAdicionalDato: PaqueteAdicionalDato, index: number) => (
                <div className={styles["separador"]}>
                  <Card>
                    <Card.Body>
                      <Row>
                        <Col className={styles["colCardBody"]}>
                          <p className={styles["paquetegb"]}>
                            <b>{paqueteAdicionalDato.NombreProductoCRM}</b>
                          </p>
                          <p className={styles["paqueteprecio"]}>
                            <b>
                              {"$"}
                              {paqueteAdicionalDato.Costo}
                            </b>
                          </p>
                          <p className={styles["textos2"]}>
                            Vigencia de 30 días
                          </p>
                          <Button
                            className={styles["botonazul"]}
                            onClick={() => {
                              contratarPaqueteDatos(
                                paqueteAdicionalDato.NombreProductoCRM,
                                paqueteAdicionalDato.Costo
                              );
                            }}
                          >
                            <b>Agregar</b>
                          </Button>{" "}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              )
            )}

            {/* 
            <div className={styles["separador"]}>
              <Card>
                <Card.Body>
                  <Row>
                    <Col className={styles["colCardBody"]}>
                      <p className={styles["paquetegb"]}>
                        <b>Recarga BTI 5 GB</b>
                      </p>
                      <p className={styles["paqueteprecio"]}>
                        <b>$15</b>
                      </p>
                      <p className={styles["textos2"]}>Vigencia de 30 días</p>
                      <Button className={styles["botonazul"]}>
                        <b>Agregar</b>
                      </Button>{" "}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>

            <div className={styles["separador"]}>
              <Card>
                <Card.Body>
                  <Row>
                    <Col className={styles["colCardBody"]}>
                      <p className={styles["paquetegb"]}>
                        <b>Recarga BTI 5 GB</b>
                      </p>
                      <p className={styles["paqueteprecio"]}>
                        <b>$15</b>
                      </p>
                      <p className={styles["textos2"]}>Vigencia de 30 días</p>
                      <Button className={styles["botonazul"]}>
                        <b>Agregar</b>
                      </Button>{" "}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>

            <div className={styles["separador"]}>
              <Card>
                <Card.Body>
                  <Row>
                    <Col className={styles["colCardBody"]}>
                      <p className={styles["paquetegb"]}>
                        <b>Recarga BTI 5 GB</b>
                      </p>
                      <p className={styles["paqueteprecio"]}>
                        <b>$15</b>
                      </p>
                      <p className={styles["textos2"]}>Vigencia de 30 días</p>
                      <Button className={styles["botonazul"]}>
                        <b>Agregar</b>
                      </Button>{" "}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>
*/}
          </Slider>
        </Row>
      </Container>

      <Modal
        show={showMOdalConfirmacion}
        onHide={handleMOdalConfirmacion}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="border-0" closeButton />
        <Modal.Body>
          <Container>
            <Row
              style={{ paddingBottom: "5px" }}
              className={styles["alignCenterCenterColumn4title"]}
            >
              <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                <ConfirmMessage
                  status={status}
                  message={message}
                  showAlert={showAlert}
                />
              </Col>
            </Row>

            <Row
              style={{ paddingBottom: "5px" }}
              className={styles["alignCenterCenterColumn4title"]}
            >
              <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                <span
                  className={styles["fontModalTitlePagar"] + " gris-oscuro"}
                >
                  Contratar Paquete
                </span>
              </Col>
            </Row>
            <Row
              style={{ paddingBottom: "5px" }}
              className={styles["alignCenterCenterColumn4title"]}
            >
              <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                <span
                  className={styles["fontModalSubtitlePagar"] + " gris-oscuro"}
                >
                  Quieres adquirir el paquete {nombrePaqueteSeleccionado} por $
                  {precioPaqueteSeleccionado}
                </span>
              </Col>
            </Row>
            <Row
              style={{ paddingBottom: "5px" }}
              className={styles["alignCenter4Button"]}
            >
              <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                <Button
                  className={styles["buttonBlueContinue"]}
                  onClick={() => {
                    isLoading(true);
                    doGestionarSSComprarDatosRest();
                    //handleMOdalConfirmacion();
                  }}
                >
                  Confirmar Cambio
                </Button>
              </Col>
            </Row>
            <Row
              style={{ paddingBottom: "5px" }}
              className={styles["alignCenter4Button"]}
            >
              <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                

                <Button
                      variant="link"
                      type="submit"
                      className={styles["linkFontEditar"]}
                      onClick={() => {
                        handleMOdalConfirmacion();
                      }}
                      style={{ width: "100%" }}
                    >
                      Cancelar
                    </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PaquetedeDatos;
